/**
 *  @class
 *  @function KitsOfferRail
 *  Carrossel da seção "Oferta de kits": rolagem nativa com scroll-snap,
 *  setas no desktop e barra de progresso no celular.
 */
if (!customElements.get('kits-offer-rail')) {
  class KitsOfferRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-kits-track]');
      if (!this.track) return;
      this.prevButton = this.querySelector('[data-kits-prev]');
      this.nextButton = this.querySelector('[data-kits-next]');
      this.nav = this.querySelector('.kits-offer__nav');
      this.progress = this.querySelector('[data-kits-progress]');
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.onScroll = () => this.update();
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.prevButton?.addEventListener('click', () => this.go(-1));
      this.nextButton?.addEventListener('click', () => this.go(1));

      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.track?.removeEventListener('scroll', this.onScroll);
    }
    go(direction) {
      // Avança o número de cards inteiros visíveis e para no início de um card.
      const slides = this.track.children;
      if (!slides.length) return;
      const step = slides.length > 1
        ? slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left
        : this.track.clientWidth;
      const perView = Math.max(1, Math.floor((this.track.clientWidth + 1) / step));
      const current = Math.round(this.track.scrollLeft / step);
      const target = Math.max(0, current + direction * perView) * step;
      this.track.scrollTo({
        left: target,
        behavior: this.reduceMotion.matches ? 'auto' : 'smooth'
      });
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const position = this.track.scrollLeft;
      if (this.nav) this.nav.hidden = max <= 1;
      if (this.prevButton) this.prevButton.disabled = position <= 1;
      if (this.nextButton) this.nextButton.disabled = position >= max - 1;
      if (this.progress) {
        const visible = Math.min(1, this.track.clientWidth / this.track.scrollWidth);
        const offset = max > 0 ? (position / max) * ((1 - visible) / visible) * 100 : 0;
        this.progress.style.setProperty('--kits-offer-progress-size', `${visible * 100}%`);
        this.progress.style.setProperty('--kits-offer-progress-offset', `${offset}%`);
      }
    }
  }
  customElements.define('kits-offer-rail', KitsOfferRail);
}
